import { Component, Input } from '@angular/core';
import { DatePipe, NgIf } from "@angular/common";
import { ClarityModule, ClrDatagridSortOrder } from "@clr/angular";
import { RouterLink } from "@angular/router";
import { AlertService, IAlertType, ProjectsStoreService } from "../../../../_shared/services";
import { Jobs } from "../../../../_shared/interfaces";

@Component({
  selector: 'app-used-in-jobs',
  standalone: true,
  imports: [
    NgIf,
    ClarityModule,
    RouterLink,
    DatePipe
  ],
  templateUrl: './used-in-jobs.component.html',
  styleUrl: './used-in-jobs.component.sass'
})
export class UsedInJobsComponent {
  jobs: Jobs[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() componentId: string = '';

  constructor(
    private prss: ProjectsStoreService,
    private alertDispatcher: AlertService
  ) { }

  ngOnInit() {
    this.loadList(this.componentId);
  }

  loadList(component: string) {
    this.prss.getUsedInJobs(component)
      .subscribe({
        next: data => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.show({
              message: ' Keine Jobs gefunden! ',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            this.loading = false;
            return;
          }
          this.jobs = data.object;
        },
        complete: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          return
        }
      })
  }
}
